import { render, staticRenderFns } from "./Cluster.vue?vue&type=template&id=6f060d1f"
import script from "./Cluster.vue?vue&type=script&lang=js"
export * from "./Cluster.vue?vue&type=script&lang=js"
import style0 from "./Cluster.vue?vue&type=style&index=0&id=6f060d1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports